export function sanitizeParticipant(raw: string): string {
  return raw
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^[-_]+|[-_]+$/g, "")
    .slice(0, 50);
}

export function isValidParticipant(p: string): boolean {
  return /^[a-z0-9_-]+$/.test(p) && p.length >= 1 && p.length <= 50;
}

export function storageKey(participant: string): string {
  return `survey-state-${participant}`;
}
